<!-- implement shopping cart rule -->
<template>
	<div class="revenuereport">
		<v-alert type="error" v-show="showTimeRangeAlert">
			{{ txt.alert.timeRangeAlert }}
		</v-alert>
		<v-alert type="warning" v-show="showTooManyRowsAlert">
			{{ txt.alert.tooManyRows }}
		</v-alert>
		<v-alert type="warning" v-show="showInvalidDateAlert">
			{{ txt.alert.invalidDate }}
		</v-alert>
		<v-alert type="error" v-show="show.dataLoadingErrorMessage">
			{{ txt.alert.dataLoadingError }}
		</v-alert>
		<v-alert type="info" v-show="showExcelJobCreatedMessage">
			{{ txt.info.exportJobCreated }}
			<v-btn
				icon
				@click="showExcelJobCreatedMessage=false"
				>
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-alert>
		<v-alert type="error" v-show="showExcelJobErrorMessage">{{txt.error.excelJobErrorMessage}}</v-alert>
		<v-alert type="error" v-show="showExcelTooManyLines">{{txt.error.excelTooManyLines}}</v-alert>

		<div v-if="this.lastImportDate" class="lastUpdate">{{txt.info.lastDataUpdate}}: {{this.lastImportDate}}</div>
		<revenuereport-selected-filter
			class="filter"
			:selectedFilters="selectedFilters"
			v-show="showSelectedFilters"
		/>
		<revenuereport-filter
			@submit="getRevenueReportData"
			@invalidDateSelected="setInvalidDateSelectedMessage"
			:approvedMandators="approvedMandators"
			:appNameShort="appNameShort"
			v-show="showFilters"
			ref="refToFilters"
		/>
		<revenuereport-sum-table
			:sums="sums"
			:pagination="pagination"
			:currencyFormat="currencyFormat"
			v-if="showSums"
		/>
		<v-flex v-if="showBackButton">
			<v-btn class="buttons" @click="showFilterContainer" :disabled="loadingData"
			>{{ txt.btn.backToFilters }}
			</v-btn>
			<v-btn class="buttons" @click="excelExport" :disabled="loadingData"
			>{{ txt.btn.excelExport }}
			</v-btn>
			<v-btn class="buttons" @click="dialogShowAccounting=true" :disabled="loadingData"
			>{{ txt.btn.excelServiceproviderExport }}
			</v-btn>
			<v-btn v-if="resellerExportEnabled" class="buttons" @click="pdfResellerExport" :disabled="loadingData"
			>{{ txt.btn.pdfResellerExport }}
			</v-btn>
		</v-flex>
		<revenuereport-table
			@tooManyRows="setTooManyRowsMessage"
			@next="nextPage"
			:revenueItems="revenueReportResult"
			:selectedFilters="selectedFilters"
			:pagination="pagination"
			:currencyFormat="currencyFormat"
			:loadingData="loadingData || paginationLoading"
			:paginationKey="paginationKey"
			:billingEngineActivated="billingEngineActivated"
			v-show="showDataTable"
			@sortHasChanged="getSortedData"
		/>

		<v-dialog v-model="dialogShowAccounting" max-width="450">
			<v-card>
				<v-card-title class="headline">{{txt.card.defineAddValues}}</v-card-title>
				<div class="popup">
					<v-form ref="formShowAccounting">
					<div class="switch" >
					<div style="padding:10px">{{txt.card.excel}}</div>
					<v-switch
						v-model="switchCsvExcelAccounting"
						color="primary"
					></v-switch>
					<div style="padding:10px">{{txt.card.csv}}</div>
					</div>
					<v-text-field
						v-model="accountingAdditionalFields.ueberweisungsart"
						label="Überweisungsart"
						v-show="switchCsvExcelAccounting"
					></v-text-field>
					<v-text-field
						v-model="accountingAdditionalFields.durchfuehrungsdatum"
						label="Durchführungsdatum"
						v-show="switchCsvExcelAccounting"
					></v-text-field>
					<v-text-field
						v-model="accountingAdditionalFields.verwendungszweck"
						label="Verwendungszweck"
						v-show="switchCsvExcelAccounting"
					></v-text-field>
					<v-text-field
						v-model="accountingAdditionalFields.auftraggeber"
						label="Auftraggeber"
						v-show="switchCsvExcelAccounting"
					></v-text-field>
					<v-text-field
						v-model="accountingAdditionalFields.auftraggeber_adresse"
						label="Auftraggeber Adresse"
						v-show="switchCsvExcelAccounting"
					></v-text-field>
					<v-text-field
						v-model="accountingAdditionalFields.auftraggeber_iban"
						label="Auftraggeber IBAN"
						v-show="switchCsvExcelAccounting"
					></v-text-field>
					<br>
					<v-btn
						class="mr-4"
						@click="excelServiceproviderExport"
					>{{txt.btn.createFile}}</v-btn>
					<v-btn
						class="mr-4"
						color="secondary"
						@click="dialogShowAccounting=false"
					>{{txt.btn.cancel}}</v-btn>
					</v-form>
				</div>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import axios from 'axios'
import RevenuereportFilter from './RevenueReportFilter.vue'
import RevenuereportTable from './RevenueReportTable.vue'
import RevenuereportSumTable from './RevenueReportSumTable.vue'
import RevenuereportSelectedFilter from './RevenueReportSelectedFilter.vue'

export default {
	name: 'RevenueReport',
	components: {
		RevenuereportFilter,
		RevenuereportTable,
		RevenuereportSelectedFilter,
		RevenuereportSumTable,
	},
	props: ['approvedRoles'],
	data() {
		return {
			showDataTable: false,
			selectedFilters: '',
			revenueReportResult: [],
			loadingData: false,
			paginationLoading: false,
			showRows: false,
			noResult: false,
			showSelectedFilters: false,
			rolesToHandle: this.approvedRoles,
			approvedMandators: [],
			appNameShort: 'rr',
			pagination: {
				rowsPerPage: 50,
				totalItems: 0,
				rowsPerPageItems: [100, 250, 500],
				page: 1,
				pages: 1,
				totalVisible: 15,
				showBottomPagination: false,
			},
			currencyFormat: {
				// set base values. needed for the Intl.NumberFormat JS function.
				// is overwritten as soon once values are loaded
				currency: 'CHF',
				locale: 'en-US',
			},
			showData: false,
			showSums: false,
			showBackButton: false,
			showFilters: true,
			txt: {
				btn: {
					backToFilters: 'Back to filters',
					excelExport: 'Detailed excel export',
					excelServiceproviderExport: 'Accounting excel/CSV export',
					pdfResellerExport: 'Reseller PDF export',
					createFile: 'Create File',
					cancel: 'cancel',
				},
				alert: {
					timeRangeAlert: `
						For excel exports the maximal time range is one month.
						Please shorten the selected period.
					`,
					tooManyRows: `
						In order not to overload the browser with data, 
						there is a limit of 100 items on expendable rows.
					`,
					invalidDate: 'The selected date is not valid.',
					dataLoadingError: 'Data could not be loaded',
				},
				info: {
					exportJobCreated: `
						Excel file creation in progress. Check your profile soon.
					`,
					lastDataUpdate: 'Last data update at',
				},
				error: {
					excelJobErrorMessage: 'Oops. something went wrong. Your report is not going to be created',
					excelTooManyLines: `
						Excel exports are limited to 250.000 lines per report. 
						Please shorten the selected time period!
					`,
				},
				card: {
					defineAddValues: 'Define additional values',
					excel: 'Excel',
					csv: 'csv',
				},
			},
			sums: [],
			rowCount: 0,
			loadingSums: false,
			showTimeRangeAlert: false,
			showTooManyRowsAlert: false,
			showInvalidDateAlert: false,
			dialogShowAccounting: false,
			accountingAdditionalFields: {},
			switchCsvExcelAccounting: false,
			showExcelJobCreatedMessage: false,
			showExcelJobErrorMessage: false,
			showExcelTooManyLines: false,
			lastImportDate: '',
			paginationKey: 0,
			show: {
				dataLoadingErrorMessage: false,
			},
			resellerExportEnabled: false,
			billingEngineActivated: false,
		}
	},
	watch: {
		'pagination.rowsPerPage': {
			handler() {
				this.getRevenueReportData()
				this.paginationKey += 1
			},
		},
		'pagination.totalItems': {
			handler() {
				this.paginationPages()
				this.paginationKey += 1
			},
		},
	},
	// eslint-disable-next-line object-shorthand, func-names
	created: async function () {
		try {
			const queryFilter = this.$route.query.filter
			// if there is a filter parameter in the url, show the data with those filters
			if (queryFilter !== undefined) {
				// get all data from database needed for filters:
				// eslint-disable-next-line no-undef
				const filterRes = await axios.get(`${config.baseAPIurl}/revenue-report/filter`, {
					params: { filterId: queryFilter },
				})

				const variables = {
					loadingData: true,
					showBackButton: true,
					showDataTable: true,
					showFilters: false,
					showSelectedFilters: true,
				}

				// convert the date into a wanted format
				filterRes.data.dateFrom = new Date(filterRes.data.dateFrom).toISOString().substr(0, 10)
				filterRes.data.dateTill = new Date(filterRes.data.dateTill).toISOString().substr(0, 10)
				if (filterRes.data.filterOnValidity) {
					// eslint-disable-next-line max-len
					filterRes.data.validityDateFrom = new Date(filterRes.data.validityDateFrom).toISOString().substr(0, 10)
					// eslint-disable-next-line max-len
					filterRes.data.validityDateTill = new Date(filterRes.data.validityDateTill).toISOString().substr(0, 10)
				}
				// saleschannels value has to be a string, otherwise it will not be shown in drop down list
				filterRes.data.salesChannels.forEach((element) => {
					element.value = element.value.toString()
				})
				filterRes.data.allowedRegions = []
				// eslint-disable-next-line max-len
				filterRes.data.region.forEach((element) => filterRes.data.allowedRegions.push({ region_id: element.value }))
				const receivedResponse = { filterData: filterRes.data, showVariables: variables, filterId: queryFilter }
				this.fillRevenueReportFilterValues(receivedResponse)
				this.getRevenueReportData(receivedResponse)
			}
		} catch (error) {
			// TDOD: show on UI if needed or not at all
			console.log(error)
		}
	},
	methods: {
		storeCommitUnseenFiles(counter) {
			if (counter < 5) {
				this.$store.commit('unseenFiles')
				counter += 1
				setTimeout(() => {
					this.storeCommitUnseenFiles(counter)
				}, 5000)
			}
		},
		async getRevenueReportData(selectedFiltersAndBooleans) {
			try {
				const filterOptions = selectedFiltersAndBooleans.filterData
				const { showVariables } = selectedFiltersAndBooleans
				this.resellerExportEnabled = selectedFiltersAndBooleans.resellerExportEnabled
				this.loadingData = showVariables.loadingData
				this.showDataTable = showVariables.showDataTable
				this.showSelectedFilters = showVariables.showSelectedFilters
				this.showSums = showVariables.showSums
				this.showBackButton = showVariables.showBackButton
				this.showFilters = showVariables.showFilters
				this.loadingData = true
				const { filterId } = selectedFiltersAndBooleans
				this.$router.push({ query: { filter: filterId } })
				this.loadingSums = true
				await this.getLastImportDate(filterOptions.mandators[0].value)

				// eslint-disable-next-line no-undef
				const sumsRes = await axios.post(`${config.baseAPIurl}/revenue-report/data-revenue-sums`, {
					filterOptions,
					pagination: this.pagination,
				})
				this.sums = sumsRes.data
				this.showSums = filterOptions.couponCode.length === 0
				this.loadingSums = false

				// eslint-disable-next-line no-undef
				const dataRowsRes = await axios.post(`${config.baseAPIurl}/revenue-report/data-revenue`, {
					filterOptions,
					pagination: this.pagination,
				})

				const billingEngineActivated = await axios.get(`${config.baseAPIurl}/revenue-report/billing-engine-activated?installationid=${filterOptions.mandators[0].value}`)
				this.billingEngineActivated = billingEngineActivated.data

				this.revenueReportResult = dataRowsRes.data
				this.selectedFilters = filterOptions
				if (filterOptions.switchOrderValidityDate || filterOptions.filterOnValidity) {
					this.selectedFilters.dateFrom = filterOptions.dateFromValidity || filterOptions.validityDateFrom
					this.selectedFilters.dateTill = filterOptions.dateTillValidity || filterOptions.validityDateTill
				}

				if (dataRowsRes.data.length > 0) this.currencyFormat.currency = dataRowsRes.data[0].order_currency_code

				// eslint-disable-next-line no-undef
				const paginationRes = await axios.post(`${config.baseAPIurl}/revenue-report/row-count`, {
					filterOptions,
					pagination: this.pagination,
				})
				this.pagination.totalItems = paginationRes.data.count

				this.loadingData = false
				this.showFilters = false
			} catch (e) {
				this.loadingData = false
				this.showFilters = true
				this.showSums = false
				this.showBackButton = false
				this.showDataTable = false
				this.selectedFilters = ''
				this.show.dataLoadingErrorMessage = true
				setTimeout(() => {
					this.show.dataLoadingErrorMessage = false
				}, 6000)
			}
		},
		async nextPage(selectedFiltersAndPagination) {
			this.paginationLoading = true
			try {
				const { filterData } = selectedFiltersAndPagination
				const { pagination } = selectedFiltersAndPagination
				// eslint-disable-next-line no-undef
				const dataRes = await axios.post(`${config.baseAPIurl}/revenue-report/data-revenue`, {
					filterOptions: filterData,
					pagination,
				})
				this.$data.revenueReportResult = dataRes.data
				if (dataRes.data.length > 0) this.currencyFormat.currency = dataRes.data[0].order_currency_code
			} catch (e) {
				// TODO handle it on the UI if needed, otherwise disable
				console.log('function next')
			} finally {
				this.paginationLoading = false
			}
		},
		async excelExport() {
			try {
				this.loadingData = true
				const response = await axios({
					// eslint-disable-next-line no-undef
					url: `${config.baseAPIurl}/revenue-report/excel/detailed`,
					method: 'post',
					responseType: 'blob',
					data: {
						filterOptions: this.selectedFilters,
						pagination: this.pagination,
						filterId: this.$router.app.$route.query.filter,
						userName: this.$keycloak.userName,
					},
				})

				let filenameExtension
				if (this.selectedFilters.dateFrom === this.selectedFilters.dateTill) {
					filenameExtension = this.selectedFilters.dateFrom
				} else {
					filenameExtension = `${this.selectedFilters.dateFrom}-${this.selectedFilters.dateTill}`
				}

				// if the excel file will be created by a job
				if (response.status === 201) {
					this.showExcelJobCreatedMessage = true
					this.storeCommitUnseenFiles(0)
				} else if (response.status === 204) {
					this.showExcelTooManyLines = true
				} else {
					// eslint-disable-next-line no-undef
					saveAs(new Blob([response.data]), `report_${filenameExtension}.xlsx`)
				}
				this.loadingData = false
				setTimeout(() => {
					this.showExcelTooManyLines = false
				}, 8000)
			} catch (error) {
				this.loadingData = false
				this.showExcelJobErrorMessage = true
				setTimeout(() => {
					this.showExcelJobErrorMessage = false
				}, 5000)
			}
		},
		async excelServiceproviderExport() {
			try {
				this.loadingData = true
				this.dialogShowAccounting = false
				let filenameExtension = ''

				const accountingDetailFilters = {
					mandators: this.selectedFilters.mandators,
					salesChannels: this.selectedFilters.salesChannels,
					serviceProviders: this.selectedFilters.serviceProviders,
					products: this.selectedFilters.products,
					skuGroups: this.selectedFilters.skuGroups,
					dateFrom: this.selectedFilters.dateFrom,
					dateTill: this.selectedFilters.dateTill,
					grouping: 'Ungrouped',
					booking: this.selectedFilters.booking,
					resellers: this.selectedFilters.resellers,
					paymentMethods: this.selectedFilters.paymentMethods,
					shoppingCartRules: this.selectedFilters.shoppingCartRules,
					couponCode: this.selectedFilters.couponCode,
					allowedRegions: this.selectedFilters.allowedRegions,
					accountingAdditionalFields: this.accountingAdditionalFields,
					switchOrderValidityDate: this.selectedFilters.switchOrderValidityDate,
					dateFromValidity: this.selectedFilters.dateFromValidity,
					dateTillValidity: this.selectedFilters.dateTillValidity,
					cashdesk: this.selectedFilters.cashdesk,
					itemStatus: this.selectedFilters.itemStatus,
				}
				let route = 'accounting'
				if (this.switchCsvExcelAccounting === true) route = 'csv'

				const response = await axios({
					// eslint-disable-next-line no-undef
					url: `${config.baseAPIurl}/revenue-report/excel/${route}`,
					method: 'post',
					responseType: 'blob',
					data: {
						filterOptions: accountingDetailFilters,
						pagination: this.pagination,
						filterId: this.$router.app.$route.query.filter,
					},
					timeout: 60 * 1000 * 10,
					headers: {
						Authorization: `Bearer ${this.$keycloak.token}`,
					},
				})

				// file naming
				if (this.selectedFilters.couponCode.length !== 0) {
					filenameExtension = `CouponCode_${this.selectedFilters.couponCode}`
				} else {
					filenameExtension = (this.selectedFilters.dateFrom === this.selectedFilters.dateTill)
						? this.selectedFilters.dateFrom
						: `${this.selectedFilters.dateFrom}-${this.selectedFilters.dateTill}`
				}
				let fileName = `accounting_report_${filenameExtension}.xlsx`
				if (this.switchCsvExcelAccounting === true) fileName = `accounting_report_${filenameExtension}.csv`

				/* react on the response */
				if (response.status === 201) {
					this.showExcelJobCreatedMessage = true
					this.storeCommitUnseenFiles(0)
				} else if (response.status === 204) {
					this.showExcelTooManyLines = true
				} else {
					// eslint-disable-next-line no-undef
					saveAs(new Blob([response.data]), fileName)
				}

				this.dialogShowAccounting = false
				this.loadingData = false
				setTimeout(() => {
					this.showExcelTooManyLines = false
				}, 8000)
			} catch (error) {
				this.loadingData = false
				this.showExcelJobErrorMessage = true
				setTimeout(() => {
					this.showExcelJobErrorMessage = false
				}, 5000)
			}
		},
		async pdfResellerExport() {
			this.loadingData = true
			try {
				const accountingDetailFilters = {
					mandators: this.selectedFilters.mandators,
					salesChannels: this.selectedFilters.salesChannels,
					serviceProviders: this.selectedFilters.serviceProviders,
					products: this.selectedFilters.products,
					skuGroups: this.selectedFilters.skuGroups,
					dateFrom: this.selectedFilters.dateFrom,
					dateTill: this.selectedFilters.dateTill,
					booking: this.selectedFilters.booking,
					resellers: this.selectedFilters.resellers,
					paymentMethods: this.selectedFilters.paymentMethods,
					shoppingCartRules: this.selectedFilters.shoppingCartRules,
					couponCode: this.selectedFilters.couponCode,
					allowedRegions: this.selectedFilters.allowedRegions,
					switchOrderValidityDate: this.selectedFilters.switchOrderValidityDate,
					dateFromValidity: this.selectedFilters.dateFromValidity,
					dateTillValidity: this.selectedFilters.dateTillValidity,
				}

				const response = await axios({
					// eslint-disable-next-line no-undef
					url: `${config.baseAPIurl}/revenue-report/pdf/reseller`,
					method: 'post',
					responseType: 'blob',
					data: {
						filterOptions: accountingDetailFilters,
						pagination: this.pagination,
						filterId: this.$router.app.$route.query.filter,
					},
					headers: {
						Authorization: `Bearer ${this.$keycloak.token}`,
					},
				})
				// file naming
				let filenameExtension = (this.selectedFilters.dateFrom === this.selectedFilters.dateTill)
					? this.selectedFilters.dateFrom
					: `${this.selectedFilters.dateFrom}-${this.selectedFilters.dateTill}`

				let fileName = `reseller_report_${filenameExtension}.pdf`
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', fileName);
				document.body.appendChild(link);
				link.click();
			} catch (error) {
				console.log(error)
			} finally {
				this.loadingData = false
			}
		},
		showFilterContainer() {
			this.showFilters = true
			this.showBackButton = false
			this.showExcelJobCreatedMessage = false
			if (this.showTimeRangeAlert) this.showTimeRangeAlert = false
			this.pagination.page = 1
			window.setTimeout(() => {
				window.scrollTo(0, 0)
			}, 10)
		},
		paginationPages() {
			const paginationPage = Math.ceil(Number(this.pagination.totalItems) / Number(this.pagination.rowsPerPage))
			this.pagination.pages = paginationPage
			this.pagination.showBottomPagination = this.pagination.pages > 1
		},
		fillRevenueReportFilterValues(receivedResponse) {
			const filters = this.$refs.refToFilters.$data.formState
			let dateSwitch = this.$refs.refToFilters.$data.switchOrderValidityDate
			filters.selectedMandators = receivedResponse.filterData.mandators
			filters.selectedSalesChannels = receivedResponse.filterData.salesChannels
			filters.selectedServiceproviders = receivedResponse.filterData.serviceProviders
			filters.selectedProducts = receivedResponse.filterData.products
			filters.selectedSkuGroups = receivedResponse.filterData.skuGroups
			filters.dateFrom = receivedResponse.filterData.dateFrom
			filters.dateTill = receivedResponse.filterData.dateTill
			filters.selectedGrouping = receivedResponse.filterData.grouping
			filters.selectedBookings = receivedResponse.filterData.booking
			filters.selectedResellers = receivedResponse.filterData.resellers
			filters.selectedPaymentMethods = receivedResponse.filterData.paymentMethods
			filters.selectedShoppingCartRule = receivedResponse.filterData.shoppingCartRules
			filters.requestedCouponCode = receivedResponse.filterData.couponCode
			filters.selectedRegions = receivedResponse.filterData.allowedRegion
			filters.selectedCashdesk = receivedResponse.filterData.cashdesk
			filters.selectedItemStatus = receivedResponse.filterData.itemStatus
			dateSwitch = receivedResponse.filterData.filterOnValidity
			if (dateSwitch) {
				filters.dateFromValidity = receivedResponse.filterData.validityDateFrom
				filters.dateTillValidity = receivedResponse.filterData.validityDateTill
			}
		},
		setTooManyRowsMessage() {
			this.showTooManyRowsAlert = true
			setTimeout(() => {
				this.showTooManyRowsAlert = false
			}, 3000)
		},
		setInvalidDateSelectedMessage() {
			this.showInvalidDateAlert = true
			setTimeout(() => {
				this.showInvalidDateAlert = false
			}, 3000)
		},
		checkFOrUnseenFiles() {
			this.$store.commit('unseenFiles')
		},
		async getLastImportDate(installationId) {
			// eslint-disable-next-line no-undef
			const response = await axios.get(`${config.baseAPIurl}
				/revenue-report/last-import-date?installationId=${installationId}
			`)
			this.lastImportDate = response.data.date
		},
		async getSortedData(selectedFiltersAndPagination) {
			const { filterOptions } = selectedFiltersAndPagination
			const { pagination } = selectedFiltersAndPagination
			this.pagination = pagination
			try {
				// eslint-disable-next-line no-undef
				const dataRowsRes = await axios.post(`${config.baseAPIurl}/revenue-report/data-revenue`, {
					filterOptions,
					pagination,
				})
				this.revenueReportResult = dataRowsRes.data
			} catch (err) {
				// TODO handle it on the UI if needed, otherwise disable
				console.log(err)
			}
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.checkFOrUnseenFiles()
		})
	},
}

</script>

<style scoped>
h3 {
	margin: 40px 0 0;
}
ul {
	list-style-type: none;
	padding: 0;
}
li {
	display: inline-block;
	margin: 0 10px;
}
a {
	color: #42b983;
}

.filter {
	margin-top: 50px;
}

.buttons {
	margin: 15px;
}

.popup {
	padding: 25px;
	margin: 0;
	height: 100%;
	overflow: hidden;
}

.switch {
	align-items: center;
	position: absolute;
	left: 50%;
	transform: translate(-50%, -50%);
	display:flex;
}
.lastUpdate{
	float: left;
	padding: 10px;
	/* padding-top: 30px; */
	color: rgba(0, 0, 0, 0.7);
}
</style>
